/** 智能选型 — 海外用户可选国家（重点市场优先，其余在 Others 前） */
export const SELECTOR_COUNTRIES = [
  { code: "US", labelKey: "countryUs" },
  { code: "GB", labelKey: "countryGb" },
  { code: "DE", labelKey: "countryDe" },
  { code: "FR", labelKey: "countryFr" },
  { code: "ES", labelKey: "countryEs" },
  { code: "IT", labelKey: "countryIt" },
  { code: "CA", labelKey: "countryCa" },
  { code: "AU", labelKey: "countryAu" },
  { code: "BR", labelKey: "countryBr" },
  { code: "IN", labelKey: "countryIn" },
  { code: "JP", labelKey: "countryJp" },
  { code: "KR", labelKey: "countryKr" },
  { code: "AE", labelKey: "countryAe" },
  { code: "SA", labelKey: "countrySa" },
  { code: "TR", labelKey: "countryTr" },
  { code: "TH", labelKey: "countryTh" },
  { code: "VN", labelKey: "countryVn" },
  { code: "ID", labelKey: "countryId" },
  { code: "MX", labelKey: "countryMx" },
  { code: "NL", labelKey: "countryNl" },
  { code: "PL", labelKey: "countryPl" },
  { code: "PT", labelKey: "countryPt" },
  { code: "RU", labelKey: "countryRu" },
  { code: "OTHER", labelKey: "countryOther" },
];

const countryNamesEn = {
  selectorCountryLabel: "Country / Region",
  selectorCountryPlaceholder: "Select your country",
  countryUs: "United States",
  countryGb: "United Kingdom",
  countryDe: "Germany",
  countryFr: "France",
  countryEs: "Spain",
  countryIt: "Italy",
  countryPt: "Portugal",
  countryBr: "Brazil",
  countryNl: "Netherlands",
  countryPl: "Poland",
  countryRu: "Russia",
  countryIn: "India",
  countryJp: "Japan",
  countryKr: "South Korea",
  countryTh: "Thailand",
  countryTr: "Turkey",
  countryVn: "Vietnam",
  countryId: "Indonesia",
  countryAe: "United Arab Emirates",
  countrySa: "Saudi Arabia",
  countryAu: "Australia",
  countryCa: "Canada",
  countryMx: "Mexico",
  countryOther: "Others",
};

export const selectorCountryTranslations = {
  en: countryNamesEn,
  de: {
    selectorCountryLabel: "Land / Region",
    selectorCountryPlaceholder: "Land auswählen",
    countryUs: "Vereinigte Staaten",
    countryGb: "Vereinigtes Königreich",
    countryDe: "Deutschland",
    countryFr: "Frankreich",
    countryEs: "Spanien",
    countryIt: "Italien",
    countryPt: "Portugal",
    countryBr: "Brasilien",
    countryNl: "Niederlande",
    countryPl: "Polen",
    countryRu: "Russland",
    countryIn: "Indien",
    countryJp: "Japan",
    countryKr: "Südkorea",
    countryTh: "Thailand",
    countryTr: "Türkei",
    countryVn: "Vietnam",
    countryId: "Indonesien",
    countryAe: "Vereinigte Arabische Emirate",
    countrySa: "Saudi-Arabien",
    countryAu: "Australien",
    countryCa: "Kanada",
    countryMx: "Mexiko",
    countryOther: "Sonstiges",
  },
  pt: {
    selectorCountryLabel: "País / Região",
    selectorCountryPlaceholder: "Selecione seu país",
    countryUs: "Estados Unidos",
    countryGb: "Reino Unido",
    countryDe: "Alemanha",
    countryFr: "França",
    countryEs: "Espanha",
    countryIt: "Itália",
    countryPt: "Portugal",
    countryBr: "Brasil",
    countryNl: "Países Baixos",
    countryPl: "Polónia",
    countryRu: "Rússia",
    countryIn: "Índia",
    countryJp: "Japão",
    countryKr: "Coreia do Sul",
    countryTh: "Tailândia",
    countryTr: "Turquia",
    countryVn: "Vietname",
    countryId: "Indonésia",
    countryAe: "Emirados Árabes Unidos",
    countrySa: "Arábia Saudita",
    countryAu: "Austrália",
    countryCa: "Canadá",
    countryMx: "México",
    countryOther: "Outro",
  },
  es: {
    selectorCountryLabel: "País / Región",
    selectorCountryPlaceholder: "Seleccione su país",
    countryUs: "Estados Unidos",
    countryGb: "Reino Unido",
    countryDe: "Alemania",
    countryFr: "Francia",
    countryEs: "España",
    countryIt: "Italia",
    countryPt: "Portugal",
    countryBr: "Brasil",
    countryNl: "Países Bajos",
    countryPl: "Polonia",
    countryRu: "Rusia",
    countryIn: "India",
    countryJp: "Japón",
    countryKr: "Corea del Sur",
    countryTh: "Tailandia",
    countryTr: "Turquía",
    countryVn: "Vietnam",
    countryId: "Indonesia",
    countryAe: "Emiratos Árabes Unidos",
    countrySa: "Arabia Saudita",
    countryAu: "Australia",
    countryCa: "Canadá",
    countryMx: "México",
    countryOther: "Otro",
  },
  fr: {
    selectorCountryLabel: "Pays / Région",
    selectorCountryPlaceholder: "Sélectionnez votre pays",
    countryUs: "États-Unis",
    countryGb: "Royaume-Uni",
    countryDe: "Allemagne",
    countryFr: "France",
    countryEs: "Espagne",
    countryIt: "Italie",
    countryPt: "Portugal",
    countryBr: "Brésil",
    countryNl: "Pays-Bas",
    countryPl: "Pologne",
    countryRu: "Russie",
    countryIn: "Inde",
    countryJp: "Japon",
    countryKr: "Corée du Sud",
    countryTh: "Thaïlande",
    countryTr: "Turquie",
    countryVn: "Vietnam",
    countryId: "Indonésie",
    countryAe: "Émirats arabes unis",
    countrySa: "Arabie saoudite",
    countryAu: "Australie",
    countryCa: "Canada",
    countryMx: "Mexique",
    countryOther: "Autre",
  },
  it: {
    selectorCountryLabel: "Paese / Regione",
    selectorCountryPlaceholder: "Seleziona il tuo paese",
    countryUs: "Stati Uniti",
    countryGb: "Regno Unito",
    countryDe: "Germania",
    countryFr: "Francia",
    countryEs: "Spagna",
    countryIt: "Italia",
    countryPt: "Portogallo",
    countryBr: "Brasile",
    countryNl: "Paesi Bassi",
    countryPl: "Polonia",
    countryRu: "Russia",
    countryIn: "India",
    countryJp: "Giappone",
    countryKr: "Corea del Sud",
    countryTh: "Thailandia",
    countryTr: "Turchia",
    countryVn: "Vietnam",
    countryId: "Indonesia",
    countryAe: "Emirati Arabi Uniti",
    countrySa: "Arabia Saudita",
    countryAu: "Australia",
    countryCa: "Canada",
    countryMx: "Messico",
    countryOther: "Altro",
  },
  hi: { ...countryNamesEn },
  ru: {
    selectorCountryLabel: "Страна / Регион",
    selectorCountryPlaceholder: "Выберите страну",
    countryUs: "США",
    countryGb: "Великобритания",
    countryDe: "Германия",
    countryFr: "Франция",
    countryEs: "Испания",
    countryIt: "Италия",
    countryPt: "Португалия",
    countryBr: "Бразилия",
    countryNl: "Нидерланды",
    countryPl: "Польша",
    countryRu: "Россия",
    countryIn: "Индия",
    countryJp: "Япония",
    countryKr: "Южная Корея",
    countryTh: "Таиланд",
    countryTr: "Турция",
    countryVn: "Вьетнам",
    countryId: "Индонезия",
    countryAe: "ОАЭ",
    countrySa: "Саудовская Аравия",
    countryAu: "Австралия",
    countryCa: "Канада",
    countryMx: "Мексика",
    countryOther: "Другое",
  },
  ko: {
    selectorCountryLabel: "국가 / 지역",
    selectorCountryPlaceholder: "국가를 선택하세요",
    countryUs: "미국",
    countryGb: "영국",
    countryDe: "독일",
    countryFr: "프랑스",
    countryEs: "스페인",
    countryIt: "이탈리아",
    countryPt: "포르투갈",
    countryBr: "브라질",
    countryNl: "네덜란드",
    countryPl: "폴란드",
    countryRu: "러시아",
    countryIn: "인도",
    countryJp: "일본",
    countryKr: "한국",
    countryTh: "태국",
    countryTr: "터키",
    countryVn: "베트남",
    countryId: "인도네시아",
    countryAe: "아랍에미리트",
    countrySa: "사우디아라비아",
    countryAu: "호주",
    countryCa: "캐나다",
    countryMx: "멕시코",
    countryOther: "기타",
  },
  ja: {
    selectorCountryLabel: "国 / 地域",
    selectorCountryPlaceholder: "国を選択してください",
    countryUs: "アメリカ",
    countryGb: "イギリス",
    countryDe: "ドイツ",
    countryFr: "フランス",
    countryEs: "スペイン",
    countryIt: "イタリア",
    countryPt: "ポルトガル",
    countryBr: "ブラジル",
    countryNl: "オランダ",
    countryPl: "ポーランド",
    countryRu: "ロシア",
    countryIn: "インド",
    countryJp: "日本",
    countryKr: "韓国",
    countryTh: "タイ",
    countryTr: "トルコ",
    countryVn: "ベトナム",
    countryId: "インドネシア",
    countryAe: "アラブ首長国連邦",
    countrySa: "サウジアラビア",
    countryAu: "オーストラリア",
    countryCa: "カナダ",
    countryMx: "メキシコ",
    countryOther: "その他",
  },
  th: {
    selectorCountryLabel: "ประเทศ / ภูมิภาค",
    selectorCountryPlaceholder: "เลือกประเทศของคุณ",
    countryUs: "สหรัฐอเมริกา",
    countryGb: "สหราชอาณาจักร",
    countryDe: "เยอรมนี",
    countryFr: "ฝรั่งเศส",
    countryEs: "สเปน",
    countryIt: "อิตาลี",
    countryPt: "โปรตุเกส",
    countryBr: "บราซิล",
    countryNl: "เนเธอร์แลนด์",
    countryPl: "โปแลนด์",
    countryRu: "รัสเซีย",
    countryIn: "อินเดีย",
    countryJp: "ญี่ปุ่น",
    countryKr: "เกาหลีใต้",
    countryTh: "ไทย",
    countryTr: "ตุรกี",
    countryVn: "เวียดนาม",
    countryId: "อินโดนีเซีย",
    countryAe: "สหรัฐอาหรับเอมิเรตส์",
    countrySa: "ซาอุดีอาระเบีย",
    countryAu: "ออสเตรเลีย",
    countryCa: "แคนาดา",
    countryMx: "เม็กซิโก",
    countryOther: "อื่นๆ",
  },
  tr: {
    selectorCountryLabel: "Ülke / Bölge",
    selectorCountryPlaceholder: "Ülkenizi seçin",
    countryUs: "Amerika Birleşik Devletleri",
    countryGb: "Birleşik Krallık",
    countryDe: "Almanya",
    countryFr: "Fransa",
    countryEs: "İspanya",
    countryIt: "İtalya",
    countryPt: "Portekiz",
    countryBr: "Brezilya",
    countryNl: "Hollanda",
    countryPl: "Polonya",
    countryRu: "Rusya",
    countryIn: "Hindistan",
    countryJp: "Japonya",
    countryKr: "Güney Kore",
    countryTh: "Tayland",
    countryTr: "Türkiye",
    countryVn: "Vietnam",
    countryId: "Endonezya",
    countryAe: "Birleşik Arap Emirlikleri",
    countrySa: "Suudi Arabistan",
    countryAu: "Avustralya",
    countryCa: "Kanada",
    countryMx: "Meksika",
    countryOther: "Diğer",
  },
  vi: {
    selectorCountryLabel: "Quốc gia / Khu vực",
    selectorCountryPlaceholder: "Chọn quốc gia của bạn",
    countryUs: "Hoa Kỳ",
    countryGb: "Vương quốc Anh",
    countryDe: "Đức",
    countryFr: "Pháp",
    countryEs: "Tây Ban Nha",
    countryIt: "Ý",
    countryPt: "Bồ Đào Nha",
    countryBr: "Brazil",
    countryNl: "Hà Lan",
    countryPl: "Ba Lan",
    countryRu: "Nga",
    countryIn: "Ấn Độ",
    countryJp: "Nhật Bản",
    countryKr: "Hàn Quốc",
    countryTh: "Thái Lan",
    countryTr: "Thổ Nhĩ Kỳ",
    countryVn: "Việt Nam",
    countryId: "Indonesia",
    countryAe: "Các Tiểu vương quốc Ả Rập Thống nhất",
    countrySa: "Ả Rập Xê-út",
    countryAu: "Úc",
    countryCa: "Canada",
    countryMx: "Mexico",
    countryOther: "Khác",
  },
  nl: {
    selectorCountryLabel: "Land / Regio",
    selectorCountryPlaceholder: "Selecteer uw land",
    countryUs: "Verenigde Staten",
    countryGb: "Verenigd Koninkrijk",
    countryDe: "Duitsland",
    countryFr: "Frankrijk",
    countryEs: "Spanje",
    countryIt: "Italië",
    countryPt: "Portugal",
    countryBr: "Brazilië",
    countryNl: "Nederland",
    countryPl: "Polen",
    countryRu: "Rusland",
    countryIn: "India",
    countryJp: "Japan",
    countryKr: "Zuid-Korea",
    countryTh: "Thailand",
    countryTr: "Turkije",
    countryVn: "Vietnam",
    countryId: "Indonesië",
    countryAe: "Verenigde Arabische Emiraten",
    countrySa: "Saoedi-Arabië",
    countryAu: "Australië",
    countryCa: "Canada",
    countryMx: "Mexico",
    countryOther: "Overig",
  },
  id: {
    selectorCountryLabel: "Negara / Wilayah",
    selectorCountryPlaceholder: "Pilih negara Anda",
    countryUs: "Amerika Serikat",
    countryGb: "Britania Raya",
    countryDe: "Jerman",
    countryFr: "Prancis",
    countryEs: "Spanyol",
    countryIt: "Italia",
    countryPt: "Portugal",
    countryBr: "Brasil",
    countryNl: "Belanda",
    countryPl: "Polandia",
    countryRu: "Rusia",
    countryIn: "India",
    countryJp: "Jepang",
    countryKr: "Korea Selatan",
    countryTh: "Thailand",
    countryTr: "Turki",
    countryVn: "Vietnam",
    countryId: "Indonesia",
    countryAe: "Uni Emirat Arab",
    countrySa: "Arab Saudi",
    countryAu: "Australia",
    countryCa: "Kanada",
    countryMx: "Meksiko",
    countryOther: "Lainnya",
  },
  ar: {
    selectorCountryLabel: "البلد / المنطقة",
    selectorCountryPlaceholder: "اختر بلدك",
    countryUs: "الولايات المتحدة",
    countryGb: "المملكة المتحدة",
    countryDe: "ألمانيا",
    countryFr: "فرنسا",
    countryEs: "إسبانيا",
    countryIt: "إيطاليا",
    countryPt: "البرتغال",
    countryBr: "البرازيل",
    countryNl: "هولندا",
    countryPl: "بولندا",
    countryRu: "روسيا",
    countryIn: "الهند",
    countryJp: "اليابان",
    countryKr: "كوريا الجنوبية",
    countryTh: "تايلاند",
    countryTr: "تركيا",
    countryVn: "فيتنام",
    countryId: "إندونيسيا",
    countryAe: "الإمارات العربية المتحدة",
    countrySa: "المملكة العربية السعودية",
    countryAu: "أستراليا",
    countryCa: "كندا",
    countryMx: "المكسيك",
    countryOther: "أخرى",
  },
  pl: {
    selectorCountryLabel: "Kraj / Region",
    selectorCountryPlaceholder: "Wybierz swój kraj",
    countryUs: "Stany Zjednoczone",
    countryGb: "Wielka Brytania",
    countryDe: "Niemcy",
    countryFr: "Francja",
    countryEs: "Hiszpania",
    countryIt: "Włochy",
    countryPt: "Portugalia",
    countryBr: "Brazylia",
    countryNl: "Holandia",
    countryPl: "Polska",
    countryRu: "Rosja",
    countryIn: "Indie",
    countryJp: "Japonia",
    countryKr: "Korea Południowa",
    countryTh: "Tajlandia",
    countryTr: "Turcja",
    countryVn: "Wietnam",
    countryId: "Indonezja",
    countryAe: "Zjednoczone Emiraty Arabskie",
    countrySa: "Arabia Saudyjska",
    countryAu: "Australia",
    countryCa: "Kanada",
    countryMx: "Meksyk",
    countryOther: "Inne",
  },
};
